<template>
  <!-- 智慧公交 -->
  <div class="scheme_container">
    <div class="scheme_wrap">
      <div class="title_wrap">{{ pageData.title }}</div>
      <div class="content_wrap">
        <div class="article_box unify_article">
          {{ pageData.text.text1 }}
        </div>
        &nbsp;
        <div
          class="img_wrap"
          v-for="(item, index) in pageData.imgArr"
          :key="`${index}-img`"
        >
          <img :src="item.imgSrc" :alt="item.alt" />
          <p class="img_caption" v-if="item.caption">{{ item.caption }}</p>
        </div>
        &nbsp;
        <div class="article_wrap" v-for="(item, index) in pageData.text.textArr" :key="index">
          <div class="subtitle">{{ item.textTitle }}</div>
          <div
            class="text unify_article"
            v-for="(itemText, indexText) in item.textContent"
            :key="`${index}-${indexText}`"
          >
            {{ itemText }}
          </div>
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageData: {
        title: '智慧公交',
        text: {
          text1:
            '瑞谦智慧公交解决方案将智能终端、公交车辆、站台与移动互联理念相融合，通过一体化的智能系统实现精准调度、实时监管和丰富的信息服务，全面提升公交管理效率与乘客出行体验。',
          textArr: [
            {
              textTitle: '精准调度与运营监管',
              textContent: [
                '结合车载智能终端与北斗/GPS 定位，实现车辆位置、速度、客流等数据的实时采集与上报。',
                '运营人员可在平台中查看线路负载、车辆状态，自动生成调度建议，做到早高峰增援、低谷期减班。'
              ]
            },
            {
              textTitle: '乘客出行体验提升',
              textContent: [
                '面向乘客开放实时到站、剩余座位等信息，帮助乘客合理规划出行时间与路线。',
                '通过站台电子站牌、移动 App、小程序等多终端同步发布运营状态，实现所见即所得的出行体验。'
              ]
            },
            {
              textTitle: '多渠道信息发布',
              textContent: [
                '站台、车辆内的多媒体屏与语音系统可实时推送突发公告、公益宣传及商业资讯。',
                '管理者可一键发布应急预警与服务通知，提升城市公交的服务触达效率。'
              ]
            }
          ]
        },
        imgArr: [
          {
            imgSrc: require('@/assets/img/solution/smart-bus.jpg'),
            alt: '智慧公交',
            caption: '智能化公交调度与信息服务'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/views/solution/unifyStyle.scss';

.img_caption {
  margin-top: 10px;
  font-size: 14px;
  color: rgba(102, 102, 102, 0.9);
  text-align: center;
}
</style>

